export default {
  "tj": {
    HOME_SHOW_SYSTEM: true,                                   // 首页是否显示系统卡片
    BIND_WECHAT: true,                                        // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/login-logo.png",        // 登录页表单logo路径
    // LOGIN_FORM_TITLE: "欢迎登录霆竣非融资性担保管理系统",            // 登录页表单标题
    LOGIN_FORM_TITLE: "欢迎登录霆竣电子保函管理系统",
    MENU_LOGO: "/static/picture/logo.png",                    // 菜单栏上方logo路径
    DOCUMENT_TITLE: "霆竣电子保函管理系统",                     // 网站标题
    COPYRIGHT: '深圳市霆竣非融资性担保有限公司',                 // 版权
    VERSION: '2.2.6',
    THEMECOLOR: '#154f9d',//  版本号
    ISSHOWOLDVERSION: true,  //是否显示旧版
  },
  "jyd": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/jyd1-login-logo.png",          // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录金源达管理系统",                       // 登录页表单标题
    MENU_LOGO: "/static/picture/jyd1-logo.png",                      // 菜单栏上方logo路径
    DOCUMENT_TITLE: "金源达管理系统",                                // 网站标题
    // COPYRIGHT: '海南金源达非融资性担保有限公司',
    COPYRIGHT: '金源达电子保函工程系统',
    VERSION: '1.1.5',
    THEMECOLOR: '#eecd22',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "hf": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/hf-login-logo1.png",          // 登录页表单logo路径
    // LOGIN_FORM_LOGO: "/static/picture/hf-login-logo.png",          // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录汇丰管理系统",                       // 登录页表单标题
    // MENU_LOGO: "/static/picture/logo.png",                      // 菜单栏上方logo路径
    MENU_LOGO: "/static/picture/hf-logo.png",                      // 菜单栏上方logo路径
    DOCUMENT_TITLE: "汇丰管理系统",                                // 网站标题
    COPYRIGHT: '深圳市汇丰融资担保有限公司',
    VERSION: '0.2.8',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "zzx": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/zzx-login-logo.png",          // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录中智信管理系统",                       // 登录页表单标题
    MENU_LOGO: "/static/picture/zzx-logo.png",                      // 菜单栏上方logo路径
    DOCUMENT_TITLE: "中智信管理系统",                                // 网站标题
    COPYRIGHT: '深圳市中智信融资担保有限公司',
    VERSION: '1.1.3',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "zs": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/zs-login-logo.png",                                           // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录中水担保管理系统",                                          // 登录页表单标题
    MENU_LOGO: "/static/picture/zs-logo.png",                                                 // 菜单栏上方logo路径
    DOCUMENT_TITLE: "中水担保管理系统",                                            // 网站标题
    COPYRIGHT: '长沙市中水融资担保有限公司',
    VERSION: '1.0.3',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "hbyh": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/yh-login-logo.png",                                           // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录亿恒担保管理系统",                                          // 登录页表单标题
    MENU_LOGO: "/static/picture/yh-logo.png",                                                 // 菜单栏上方logo路径
    DOCUMENT_TITLE: "亿恒担保管理系统",                                            // 网站标题
    COPYRIGHT: '河北亿恒融资担保有限公司',
    VERSION: '1.0.4',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "zkhz": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/zkhz-login-logo.png",                                           // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录中康惠众担保管理系统",                                          // 登录页表单标题
    MENU_LOGO: "/static/picture/zkhz-logo.png",                                                 // 菜单栏上方logo路径
    DOCUMENT_TITLE: "中康惠众担保管理系统",                                            // 网站标题
    COPYRIGHT: '中康惠众融资担保（长春）有限公司',
    VERSION: '1.0.6',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "ln": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/ln-login-logo.png",                                           // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录辽宁担保管理系统",                                          // 登录页表单标题
    MENU_LOGO: "/static/picture/ln-logo.png",                                                 // 菜单栏上方logo路径
    DOCUMENT_TITLE: "辽宁担保管理系统",                                            // 网站标题
    COPYRIGHT: '辽宁省融资担保集团有限公司',
    VERSION: '1.0.1',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "yc": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/yc-login-logo.png",                                           // 登录页表单logo路径
    LOGIN_FORM_TITLE: "欢迎登录湖南益诚融资担保管理系统",                                          // 登录页表单标题
    MENU_LOGO: "/static/picture/yc-logo.png",                                                 // 菜单栏上方logo路径
    DOCUMENT_TITLE: "湖南益诚融资担保",                                            // 网站标题
    COPYRIGHT: '湖南益诚融资担保股份有限公司',
    VERSION: '1.0.1',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  },
  "kr": {
    HOME_SHOW_SYSTEM: false,                                        // 首页是否显示系统卡片
    BIND_WECHAT: false,                                             // 绑定微信
    LOGIN_FORM_LOGO: "/static/picture/kr-login-logo.png",                                           // 登录页表单logo路径
    LOGIN_FORM_TITLE: "凯仁电子保函工程咨询管理系统",                                          // 登录页表单标题
    MENU_LOGO: "/static/picture/kr-logo.png",                                                 // 菜单栏上方logo路径
    DOCUMENT_TITLE: "凯仁非融资担保",                                            // 网站标题
    COPYRIGHT: '凯仁非融资担保有限公司',
    VERSION: '1.0.5',
    ISSHOWOLDVERSION: false,  //是否显示旧版
  }
}